import type { ImageProps } from 'next/image';
import Image from 'next/image';
import { cn } from '@/lib/cn';
import { type CmsImageData } from '@/services/cms-sdk';

export interface CmsImageProps extends Omit<CmsImageData, 'className'> {
    loading?: ImageProps['loading'];
    style?: ImageProps['style'];
    sizes?: ImageProps['sizes'];
    quality?: number | `${number}`;
    preload?: boolean;
    placeholder?: ImageProps['placeholder'];
    blurDataURL?: string;
    fill?: boolean;
    className?: string;
    enableFocusPoint?: boolean;
}

export function CmsImage({
    link,
    name,
    title,
    width,
    height,
    loading,
    style,
    sizes,
    quality,
    preload,
    placeholder,
    blurDataURL,
    fill: fillIn,
    className,
    enableFocusPoint: enableFocusPointIn,
    focusPoint,
}: CmsImageProps) {
    const enableFocusPoint = enableFocusPointIn && Boolean(focusPoint?.percentageX !== undefined && focusPoint?.percentageY !== undefined);
    const fill = fillIn || enableFocusPoint;
    return (
        <Image
            src={link}
            alt={title || name || ''}
            width={fill ? undefined : width}
            height={fill ? undefined : height}
            loading={loading}
            style={{
                ...style,
                ...(enableFocusPoint
                    ? {
                          objectPosition: `${focusPoint?.percentageX}% ${focusPoint?.percentageY}%`,
                      }
                    : undefined),
            }}
            sizes={sizes}
            quality={quality}
            preload={preload}
            fetchPriority={preload ? 'high' : undefined}
            placeholder={placeholder}
            blurDataURL={blurDataURL}
            fill={fill}
            className={cn(className, { 'object-cover': enableFocusPoint })}
        />
    );
}
